(function () {
  if (window.__headerShInit) return;
  window.__headerShInit = true;

  function init() {
    var drawer = document.querySelector('[data-header-sh-drawer]');
    var openBtn = document.querySelector('[data-header-sh-drawer-open]');

    function setDrawer(open) {
      if (!drawer) return;
      drawer.classList.toggle('is-open', open);
      drawer.setAttribute('aria-hidden', open ? 'false' : 'true');
      if (openBtn) openBtn.setAttribute('aria-expanded', open ? 'true' : 'false');
      document.body.style.overflow = open ? 'hidden' : '';
    }

    if (openBtn) openBtn.addEventListener('click', function () { setDrawer(true); });

    document.addEventListener('click', function (e) {
      // close drawer
      if (e.target.closest('[data-header-sh-drawer-close]')) {
        setDrawer(false);
        return;
      }

      // accordion toggle: tapping anywhere on a row that has a submenu opens it
      var toggleRow = e.target.closest('[data-header-sh-drawer-toggle]');
      if (toggleRow) {
        e.preventDefault();
        var item = toggleRow.parentElement;
        if (item) item.classList.toggle('is-open');
        return;
      }
    });

    document.addEventListener('keydown', function (e) {
      if (e.key === 'Escape') setDrawer(false);
    });

    // Desktop nav arrows
    var nav = document.querySelector('[data-header-sh-nav]');
    var scroller = document.querySelector('[data-header-sh-nav-scroll]');
    var prev = document.querySelector('[data-header-sh-nav-prev]');
    var next = document.querySelector('[data-header-sh-nav-next]');

    if (nav && scroller && prev && next) {
      var step = function () { return scroller.clientWidth * 0.6; };

      function updateArrows() {
        var max = scroller.scrollWidth - scroller.clientWidth;
        var overflow = max > 2;
        nav.classList.toggle('has-overflow', overflow);
        prev.classList.toggle('is-visible', overflow && scroller.scrollLeft > 2);
        next.classList.toggle('is-visible', overflow && scroller.scrollLeft < max - 2);
      }

      prev.addEventListener('click', function () {
        scroller.scrollBy({ left: -step(), behavior: 'smooth' });
      });
      next.addEventListener('click', function () {
        scroller.scrollBy({ left: step(), behavior: 'smooth' });
      });
      scroller.addEventListener('scroll', updateArrows, { passive: true });
      window.addEventListener('resize', updateArrows);
      updateArrows();
    }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();